module.exports = __webpack_public_path__ + "img/LogoDashboard-22.9e90cdfb.svg";